import React from 'react'

import {connect} from "react-redux";
import AdminSideBar from "../nav/AdminSideBar";
import AlertFeed from "../alerts/alertFeed";
import PacefiFullScreenSpinner from "../loaders/pacefiFullScreenSpinner";


class AdminWrapper extends React.Component {


    render() {
        return (
            <div className={'page-wrapper'}>
                <div className={'columns full-screen-height is-clipped'}>
                    <div className={'column is-one-fifth has-background-info has-text-light'} style={{maxWidth: '15em'}}>
                        <AdminSideBar/>
                    </div>
                    <div className={'column y-overflow has-background-white-bis'}>
                        {this.props.children}
                    </div>
                </div>
                <div id="admin-wrapper-alert-feed">
                    <AlertFeed/>
                </div>
                <PacefiFullScreenSpinner/>
            </div>
        )
    }
}



export default AdminWrapper //connect()(AdminWrapper)
